type SmartMorningProgress = {
  currentNode?: string | null;
  currentKind?: string | null;
  currentPipeline?: string | null;
  currentMessage?: string | null;
};

const STATUS_STAGE_RANK: Record<string, number> = {
  'Understanding your question': 0,
  'Fetching SAP data': 1,
  'Summarizing your answer': 2,
};

export const getSmartMorningStatusStage = (
  progress: SmartMorningProgress,
  previousStage = 'Understanding your question',
): string => {
  const node = `${progress.currentNode || ''} ${progress.currentPipeline || ''} ${progress.currentMessage || ''}`.toLowerCase();
  const kind = `${progress.currentKind || ''}`.toLowerCase();
  const currentStage = /insight|assembl|finaliz|narrat|summary/.test(node)
    ? 'Summarizing your answer'
    : kind === 'tool' || kind === 'tool_call' || /tool|fetch|data|metric|chart|retriev/.test(node)
      ? 'Fetching SAP data'
      : /context|intent|plan|agent|question|classif/.test(node) || !node.trim()
        ? 'Understanding your question'
        : 'Fetching SAP data';
  return STATUS_STAGE_RANK[currentStage] >= STATUS_STAGE_RANK[previousStage]
    ? currentStage
    : previousStage;
};
